module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Chat":"Chat","Introduction":"Introduction"},"zh":{"Chat":"讨论区","Introduction":"直播介绍"}}')
  delete Component.options._Ctor
}
